<div class="cms-tooltip-wrapper {wrapperClasses} cms-tw" style={wrapperStyle} bind:this={wrapperElement}>
  <div class="cms-tooltip-slot {slotClass}" on:mouseover={setTop} on:focus={setTop}>
    <slot />
  </div>

  <div
    class="tooltip"
    class:active
    class:left
    class:right
    class:bottom
    class:top
    style={tooltipStyle}
  >
    {#if videoPath && tooltipText}
      <div class="cms-default-tip" {style}>
        <video src="" width="320x" height="180px" autoplay loop>
          <track kind="captions">
          <source type="video/mp4" src={videoPath}>
        </video>
        <div class="cms-tooltip video-text">
          {@html tooltipText}
        </div>
      </div>
    {:else if tip && !disabled}
      <div class="shadow-lg bg-gray-700 text-white p-4 rounded-md" style="z-index: 999999">{tip}</div>
    {:else}
      <slot name="cms-custom-tip" />
    {/if}
  </div>
</div>

<script>
  export let wrapperClasses = ''
  export let slotClass = ''
  export let tip = ''
  export let top = false
  export let right = false
  export let bottom = false
  export let left = false
  export let active = false
  export let color = '#000'
  export let videoPath = ''
  export let tooltipText = ''
  export let wrapperStyle = ''
  export let disabled = false

  const style = `background-color: ${color};`
  let wrapperElement = null
  let tooltipStyle = ''

  function setTop () {
    if (wrapperElement) {
      tooltipStyle = `top: ${wrapperElement?.getBoundingClientRect().top}px`
    }
  }
</script>

<style>
  .cms-tooltip-wrapper {
    position: relative;
    width: 100%;
    display: flex;
    align-items: center;
  }

  .tooltip {
    position: fixed;
    font-family: inherit;
    display: inline-block;
    white-space: nowrap;
    color: inherit;
    opacity: 0;
    visibility: hidden;
    transition: opacity 150ms, visibility 150ms;
  }

  .cms-default-tip {
    display: inline-block;
    padding: 8px 8px;
    border-radius: 6px;
    color: #fff;
    font-size: 12px;
    box-shadow: 0px 0px 10px rgba(0,0,0,0.2);
  }

  .tooltip.top {
    left: 50%;
    transform: translate(-50%, -100%);
    margin-top: -8px;
  }

  .tooltip.bottom {
    transform: translateX(-50%) translateY(130%);
    z-index: 999999;
  }

  .tooltip.left {
    transform: translateX(-60px);
    margin-left: -8px;
  }

  .tooltip.right {
    transform: translateX(60px);
    margin-left: -8px;
  }

  .tooltip.active {
    opacity: 1;
    visibility: initial;
  }

  .cms-tooltip-slot {
    display: flex;
    align-items: center;
  }

  .cms-tooltip-slot:hover + .tooltip {
    opacity: 1;
    visibility: initial;
    z-index: 999;
  }

  .video-text {
    padding: 8px 0px;
    font-weight: 500;
  }

</style>
<script context="module">export const svelteCompilerVersion = {"major":4,"minor":2,"patch":18};</script>